import IFormViewConfigurationV2 from '../Types/V2/IFormViewConfigurationV2'
import makeRequest, { ERequestMethod } from '../../rest-api'

export const fetchFormView = async (id: string): Promise<IFormViewConfigurationV2 | null> => {
    return await makeRequest<IFormViewConfigurationV2 | null>({
        method: ERequestMethod.GET,
        url: `ViewEngine/FormView?id=${id}`,
    })
}
